import { EventEmitter, Injectable } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { Observable, of, Subject, Subscription } from 'rxjs'
import { catchError, map, shareReplay } from 'rxjs/operators'
import { UserSecurityProfileService } from 'src/app/core/services/user-security-profile.service'

import { environment } from '../../../environments/environment'
import { HttpService, HTTPServiceParameter } from '../../core'

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  shareDataSubject = new Subject<any>() // Decalring new RxJs Subject
  shareRedirectSubject = new Subject<any>()
  equitySubject = new Subject<any>()
  dbppSubject = new Subject<any>()
  searchForClientPlanDataSubject = new Subject<any>()
  loaderStatus = new Subject<boolean>()
  showPlanHealthErrorBanner = new Subject<any>()
  showErrorBanner = new Subject<any>()
  showPageNotFound = new Subject<any>()
  updatePagesWithNewPlans = new Subject<any>()
  invokeFirstComponentFunction = new EventEmitter()
  subsVar!: Subscription
  allLabelsForGlobalMenus: any
  allLabelsForGlobalLeftNav: any
  allLabelsForTodayPage: any
  allLabelsNewForTodayPage: any
  shareclientPlanDataSubject = new Subject<any>()
  selectedPlans: any = []
  shareClientSubject = new Subject<any>()
  planTypeVanguardNqp: string | undefined
  allLabelsNewForTodayPageComponenet: any
  CoexsitanceMultiPlanTypePermissionObj: any
  employeeProfileSeachSubject = new Subject<any>()
  walkThroughEventEmit = new EventEmitter()
  allEmployeeSearchLabels: any
  selectedClientEmployeeSearch: any
  resetGlobalNavSearch = new Subject<any>()
  reloadPlansResetCookie = new Subject<any>()
  subscriptionArray: Subscription[] = []
  messageCount$: any
  currentUserPlans$: any
  equityAllocations$: any
  planSummary$: any
  allPreferredPlans$: any
  currentUserSPOID$: any
  currentUserDemographics$: any
  planTypesAttributes: any
  defaultPlanCheck = new Subject<any>()

  constructor(
    private httpService: HttpService,
    private userProfile: UserSecurityProfileService,
    private cookieService: CookieService,
  ) {}
  getUserProfile = () => {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      '/plan-sponsor-security-admin/v1/current-user-profile'
    return this.httpService.get<any>(param)
    // Local App Testing SBF checks if Required.
    // let param = new  HTTPServiceParameter();
    // param.url = 'me/assets/todayspage/db.json';
    // return this.httpService.get<any>(param);
  }

  getESTDate(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      '/utility/v1/currentdate-est-timezone'
    return this.httpService.get<any>(param)
  }
  getPrevBusinessDate(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      '/utility/v1/previous-business-date'
    return this.httpService.get<any>(param)
  }
  sendPageRedirection = (data: any) => {
    this.shareRedirectSubject.next(data)
  }
  sendDataToOtherComponent = (data: any) => {
    this.shareDataSubject.next(data)
    this.setLocalStoragePlanId(data)
  }
  setLocalStoragePlanId(data) {
    localStorage.setItem('newMPMPlan', data)
  }
  sendDataToEmployeeSearchBar = (data: any) => {
    this.employeeProfileSeachSubject.next(data)
  }
  sendDataToGlobalNavSearchBar = (data: any) => {
    this.resetGlobalNavSearch.next(data)
  }
  sendUpdatePagesWithNewPlans = (data: any) => {
    this.updatePagesWithNewPlans.next(data)
  }
  sendSelectedClientId = (data: any) => {
    this.shareClientSubject.next(data)
  }
  sendEquityFlag = (data: any) => {
    this.equitySubject.next(data)
  }
  sendDbppSubject = (data: any) => {
    this.dbppSubject.next(data)
  }
  onShowPlanHealthError = (data: any) => {
    this.showPlanHealthErrorBanner.next(data)
  }
  resetReloadPlanCookie = (data: any) => {
    this.reloadPlansResetCookie.next(data)
  }
  onShowError = (data: any) => {
    this.showErrorBanner.next(data)
  }
  onComponentButtonClick = () => {
    this.invokeFirstComponentFunction.emit()
  }
  onShowPageNotFound = (data: any) => {
    this.showPageNotFound.next(data)
  }
  getallPreferredPlans(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/plan-sponsor-security-admin/v1/current-user-plans/all-preferred-plans`
    return this.httpService
      .get<any>(param)
      .pipe((result) => result, shareReplay())
  }

  getAllInternalPlans(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/plan-sponsor-security-admin/v1/current-user-plans/all-internal-plans`
    return this.httpService.get<any>(param)
  }

  getClientInfo(): Observable<any> {
    const param = new HTTPServiceParameter()
    // tslint:disable-next-line:max-line-length
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/plan-sponsor-security-admin/v1/current-user-plans`
    return this.httpService
      .get<any>(param)
      .pipe((result) => result, shareReplay())
  }

  getUserDefaultClientPlan(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/user-preferences/v1/preferences/plans/default`
    return this.httpService.get<any>(param)
  }

  addPlan(PreferredPlans: any): Observable<any> {
    const param = new HTTPServiceParameter()
    param.body = {
      preferredPlans: PreferredPlans,
    }
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/user-preferences/v1/preferences/plans/addPreferredPlans`
    return this.httpService.post(param)
  }
  removePlan(PreferredPlans: any): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/user-preferences/v1/preferences/plans/removePreferredPlans`
    param.body = PreferredPlans
    return this.httpService.post(param)
  }
  DefaultPlan(defaultPlan: any, PreferredPlans: any): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/user-preferences/v1/preferences/plans/setDefaultPlan`
    param.body = { defaultPlanId: defaultPlan, preferredPlans: PreferredPlans }
    return this.httpService.post(param)
  }
  equityAllocationData(planId: any): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_PLANS +
      environment.PORTNUMBER +
      `/plan-summary/v1/plan/${planId}/equityAllocations`
    return this.httpService.get<any>(param).pipe(
      map((res) => res),
      catchError(() => of('tranError')),
      shareReplay(),
    )
  }

  getLabelsForGlobalMenus(): Observable<any> {
    const param = new HTTPServiceParameter()
    //param.url = '/dcrkpublic/assets/CMS/global-menus.json'
    param.url =environment.PRODUCTION? '/dcrkpublic/assets/CMS/global-menus.json':environment.BASE_HREF + 'assets/CMS/global-menus.json'
    return this.httpService.get<any>(param)
  }
  setAllLabelsForGlobalMenus = (data: any) => {
    this.allLabelsForGlobalMenus = data
  }
  getAllLabelsForGlobalMenus = () => {
    return this.allLabelsForGlobalMenus
  }

  getLabelsForGlobalLeftNav(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url = environment.BASE_HREF + 'assets/CMS/global-left-nav.json'
    return this.httpService.get<any>(param)
  }
  setAllLabelsForGlobalLeftNav = (data: any) => {
    this.allLabelsForGlobalLeftNav = data
  }
  getAllLabelsForGlobalLeftNav = () => {
    return this.allLabelsForGlobalLeftNav
  }
  getLabelsForTodayPage(): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url = environment.BASE_HREF + 'assets/CMS/Today_Page.json'
    return this.httpService.get<any>(param)
  }
  displayLoader = (value: boolean) => {
    this.loaderStatus.next(value)
  }

  setMultipleSelectionPlanType = (value: string) => {
    this.planTypeVanguardNqp = value
  }

  getMultipleSelectionPlanType = () => {
    return this.planTypeVanguardNqp
  }

  setselectedPlans = (value: any[]) => {
    this.selectedPlans = value
  }

  getselectedPlans = () => {
    return this.selectedPlans
  }

  getPlanTypesAttributes(planId: any): Observable<any> {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_PLANS +
      environment.PORTNUMBER +
      `/plan-demographics/v1/plan/${planId}/plan-type-attributes`
    return this.httpService.get<any>(param)
  }

  setAllLabelsNewForTodaysPage = (data: any) => {
    this.allLabelsNewForTodayPage = data
  }
  getAllLabelsNewForTodayPage = () => {
    return this.allLabelsNewForTodayPage
  }
  setAllLabelsNewForTodaysPageComponent = (data: any) => {
    this.allLabelsNewForTodayPageComponenet = data
  }
  getAllLabelsNewForTodaysPageComponent = () => {
    return this.allLabelsNewForTodayPageComponenet
  }
  searchAndPreferredClientPlans = (selectedPlan: any): Observable<any> => {
    const param = new HTTPServiceParameter()
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      '/plan-sponsor-security-admin/v1/current-user-plans/searched-and-preferred-clients-plans?searchClientPlans=' +
      `${selectedPlan}`
    return this.httpService.get<any>(param)
  }

  sendclientPlanDataToOtherComponent = (data: any) => {
    this.shareclientPlanDataSubject.next(data)
  }
  sendSearchForClientDataSubject = (data: any) => {
    this.searchForClientPlanDataSubject.next(data)
  }
  setCoexsitanceMultiPlanTypePermissionObj(data: any) {
    this.CoexsitanceMultiPlanTypePermissionObj = data
  }
  getCoexsitanceMultiPlanTypePermissionObj() {
    return this.CoexsitanceMultiPlanTypePermissionObj
  }
  getCurrentUserSPOID(): Observable<any> {
    const param = new HTTPServiceParameter()
    // tslint:disable-next-line:max-line-length
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/plan-sponsor-security-admin/v1/current-user-spoid`
    return this.httpService
      .get<any>(param)
      .pipe((result) => result, shareReplay())
  }
  getCurrentUserDemographics(): Observable<any> {
    const param = new HTTPServiceParameter()
    // tslint:disable-next-line:max-line-length
    param.url =
      environment.BASEURL +
      environment.INST_OTHER +
      environment.PORTNUMBER +
      `/crew-demographics/v1/current-user-demographics`
    return this.httpService
      .get<any>(param)
      .pipe((result) => result, shareReplay())
  }

  filterPlanIdsByPlanHealthPermission(value) {
    let tempArray = value.split(',')
    let planHealthPermitIds = tempArray
      .filter((plan: any) => {
        return this.userProfile.hasPlanPermission(
          'SVC_VIEW_PLAN_FINANCIAL_INFORMATION',
          [plan],
        )
      })
      .sort(function (a, b) {
        return b - a
      })
    return planHealthPermitIds.toString()
  }

  sortSinglePlanIdByAsc(value: any) {
    let planIdsStr = value
    let sortedPlanId = planIdsStr.split(',').sort((a, b) => a - b)[
      (planIdsStr as any, planIdsStr.split(',').sort((a, b) => a - b)).length -
        1
    ]
    return sortedPlanId
  }

  setAllLabelsEmployeeSearch = (data: any) => {
    this.allEmployeeSearchLabels = data
  }
  getAllLabelsEmployeeSearch = () => {
    return this.allEmployeeSearchLabels
  }
  setSelectedClientIdForEmpSearch = (val: any) => {
    this.selectedClientEmployeeSearch = val
  }
  getSelectedClientIdForEmpSearch = () => {
    return this.selectedClientEmployeeSearch
  }
  getRoutingURL(moduleName: any) {
    let returnValue: any
    switch (moduleName) {
      case 'Home':
        returnValue = '/todays/todays-layout'
        break
      case 'Employee Profile':
        returnValue = '/employee-profile/employee-layout'
        break
      case 'Help Center':
        returnValue = '/help-center'
        break
      case 'My Profile':
        returnValue = '/my-profile'
        break
      case 'Security Center':
        returnValue = '/security-admin'
        break
    }
    return returnValue
  }
  collectSubscriptions(value: any) {
    this.subscriptionArray.push(value)
  }
  resetSubscriptions() {
    this.subscriptionArray.forEach((subscription: any) => {
      if (subscription) {
        subscription.unsubscribe()
      }
    })
  }
  deleteReloadPlanCookie = () => {
    this.cookieService.delete('reloadPlan', '/')
  }

  removeAttributeAccessibilityByClassName = (className: any, timeOut: any) => {
    window.setTimeout(function () {
      const arr: HTMLCollection = document.getElementsByClassName(className)
      for (let i = 0; i < arr.length; i++) {
        arr[i].removeAttribute('aria-autocomplete')
        arr[i].removeAttribute('aria-expanded')
        arr[i].removeAttribute('aria-required')
      }
    }, timeOut)
  }
  removeAttributeAccessibilityById = (elementId: any, timeOut: any) => {
    window.setTimeout(function () {
      const arr: any = document.getElementById(elementId)
      if (arr) {
        arr.removeAttribute('aria-autocomplete')
        arr.removeAttribute('aria-expanded')
        arr.removeAttribute('aria-required')
      }
    }, timeOut)
  }
  searchClientPlanText: string = ''
  setsearchClientPlanFilterValue = (val: string) => {
    this.searchClientPlanText = val
  }
  getsearchClientPlanFilterValue = () => {
    return this.searchClientPlanText
  }
  setPlanTypesAttributesDetails = (data: any) => {
    this.planTypesAttributes = data
  }
  getPlanTypesAttributesDetails = () => {
    return this.planTypesAttributes
  }
  updateDefaultPlan = (item: any) => {
    this.defaultPlanCheck.next(item)
  }
}
